var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgPentolaIcon = function SvgPentolaIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 146 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.087 68.236c-.317-8.191-5.256-15.172-12.277-18.465V10.977h-18.07V49.75c-7.021 3.293-11.96 10.274-12.278 18.465h-.039v87.704h42.724V68.216h-.04l-.02.02Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.765 20.02a9.044 9.044 0 1 0 0-18.087 9.044 9.044 0 0 0-9.044 9.044 9.044 9.044 0 0 0 9.044 9.044ZM144.127 155.92c0 11.801-9.56 21.361-21.342 21.361-11.782 0-21.362-9.56-21.362-21.361s9.56-21.36 21.362-21.36c11.801 0 21.342 9.559 21.342 21.36Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.646 148.879v-.476c0 .318 0 .635.02.952-.02-.158-.02-.317-.02-.476Z",
    stroke: "#B43028",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.463 84.698v63.705c0-14.042-11.365-25.406-25.408-25.406-14.043 0-25.409 11.364-25.409 25.406V84.698c0-14.042 11.386-25.407 25.409-25.407s25.408 11.365 25.408 25.407Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.443 149.355c.02-.317.02-.634.02-.952v.476c0 .159 0 .318-.02.476Z",
    stroke: "#B43028",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.463 148.403c0 .318 0 .635-.02.952 0 .06 0 .119-.02.179-.575 13.526-11.702 24.276-25.368 24.276-13.666 0-24.794-10.75-25.369-24.276-.02-.06-.02-.119-.02-.179-.02-.317-.02-.634-.02-.952 0-14.042 11.386-25.406 25.409-25.406s25.408 11.364 25.408 25.406Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.055 110.105c14.032 0 25.408-11.375 25.408-25.407S54.087 59.291 40.055 59.291c-14.033 0-25.409 11.375-25.409 25.407s11.376 25.407 25.409 25.407Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.646 106.138c-.198 0-.396.04-.595.04-4.76 0-8.628-3.868-8.628-8.628s3.868-8.627 8.629-8.627a3 3 0 0 1 .595.04v-3.928c-.199 0-.397-.04-.595-.04A12.545 12.545 0 0 0 1.496 97.55a12.545 12.545 0 0 0 12.556 12.555c.198 0 .396-.02.595-.04v-3.927ZM65.463 88.962c.198 0 .397-.04.595-.04 4.76 0 8.628 3.868 8.628 8.628s-3.868 8.628-8.628 8.628c-.198 0-.397 0-.595-.04v3.927c.198 0 .397.04.595.04A12.545 12.545 0 0 0 78.613 97.55a12.545 12.545 0 0 0-12.555-12.554c-.198 0-.397.02-.595.04v3.926Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
var Memo = /*#__PURE__*/memo(SvgPentolaIcon);
export { Memo as ReactComponent };
export default "/_next/static/svg/886e5ac1104da4e41dd362683d1e6453.svg";